import { render } from "./ProfileEditorDialog.vue?vue&type=template&id=7c8a8bac&scoped=true&lang=pug"
import script from "./ProfileEditorDialog.vue?vue&type=script&lang=js"
export * from "./ProfileEditorDialog.vue?vue&type=script&lang=js"

import "./ProfileEditorDialog.vue?vue&type=style&index=0&id=7c8a8bac&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8a8bac"]])

export default __exports__